

export default function(element: Ref<unknown | null | HTMLElement>) {
  return {
    addClass(className: string) {
      (element.value as HTMLElement).classList.add(className)
    },

    removeClass(className: string) {
      (element.value as HTMLElement).classList.remove(className)
    }
  }
}